import EntryActionTypes from '../constants/EntryActionTypes';
import ModalTypes from '../constants/ModalTypes';

const openUsersModal = () => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.USERS,
  },
});

const openArchiveModal = () => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.ARCHIVE,
  },
});

const openUserSettingsModal = () => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.USER_SETTINGS,
  },
});

const openProjectAddModal = () => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.PROJECT_ADD,
  },
});

const openProjectSettingsModal = () => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.PROJECT_SETTINGS,
  },
});

const openMonthlyReportModal = (listId) => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.MONTHLY_REPORT,
    data: {
      listId,
    },
  },
});

const openUnclosedTasksModal = (unclosedTasks) => ({
  type: EntryActionTypes.MODAL_OPEN,
  payload: {
    type: ModalTypes.UNCLOSED_TASKS,
    data: {
      unclosedTasks,
    },
  },
});

const closeModal = () => ({
  type: EntryActionTypes.MODAL_CLOSE,
  payload: {},
});

export default {
  openArchiveModal,
  openUsersModal,
  openUserSettingsModal,
  openProjectAddModal,
  openProjectSettingsModal,
  openMonthlyReportModal,
  openUnclosedTasksModal,
  closeModal,
};
